import type { FC } from "react";
import { SharedToolFormFields } from "./sharedToolFormFields.js";

interface CallEndToolFormProps {
  name: string;
  description: string;
  settings: CallEndToolFormSettings;
  onNameChange: (name: string) => void;
  onDescriptionChange: (description: string) => void;
  onSettingsChange: (settings: Partial<CallEndToolFormSettings>) => void;
}

export interface CallEndToolFormSettings {}

export const CallEndToolForm: FC<CallEndToolFormProps> = ({
  name,
  description,
  onNameChange,
  onDescriptionChange,
}) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      <SharedToolFormFields
        name={name}
        description={description}
        onNameChange={onNameChange}
        onDescriptionChange={onDescriptionChange}
        namePlaceholder="End call"
        descriptionPlaceholder="Ends the current call."
      />
    </div>
  );
};
